<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div class="body tabs">
  <input
    type="radio"
    name="tab"
    id="tab1"
    checked="checked"
    (change)="changeTabs(0)"
  />
  <i
  class="fa fa-angle-double-right"
  style="font-size: small; color: #3086f8"
  aria-hidden="true"
></i>
  <label for="tab1" class="tab1">REGISTRATION</label>
  <i
    class="fa fa-angle-double-left"
    style="font-size: small; color: #3086f8"
    aria-hidden="true"
  ></i>
  <!-- <input type="radio" name="tab" id="tab2" (change)="changeTabs(1)" />
  <label for="tab2" class="tab2">ZONALS</label>
  <i
    class="fa fa-angle-double-right"
    style="font-size: small; color: #3086f8"
    aria-hidden="true"
  ></i>
  <input type="radio" name="tab" id="tab3" (change)="changeTabs(2)" />
  <label for="tab3" class="tab3">BUSINESS MODEL</label>
  <i
    class="fa fa-angle-double-right"
    style="font-size: small; color: #3086f8"
    aria-hidden="true"
  ></i>
  <input type="radio" name="tab" id="tab4" (change)="changeTabs(3)" />
  <label for="tab4" class="tab4">FINALE</label> -->

  <!-- <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
        <section class="tf-section section-roadmap2 section-bg-1">

          <div class="container w-100">
              <div class="row">
                  <div class="col-md-12">
                      <div class="tf-roadmap style2" *ngIf="true">
                              <div *ngFor="let idx of reglist">
                                  <div key={{idx.id}} class="roadmap-box-2 {{idx.classname}}" data-wow-duration="1.5s">
                                      <div class="content">
                                          <h4 class="date">{{idx.dates}}</h4>
                                          <h4 class="title">{{idx.sub_title}}</h4>
                                          <p class="detailing">{{idx.description}}</p>
                                      </div>
                                      <span ></span>
                                      <div class="shape-circle">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="176" height="60" viewBox="0 0 176 60" fill="none">
                                              <path d="M0 30L136 30" stroke="white" stroke-width="2" stroke-dasharray="6 6"/>
                                              <circle cx="146" cy="30" r="30" transform="rotate(90 146 30)" fill="#00C4F4" fill-opacity="0.2"/>
                                              <circle cx="146" cy="30" r="15" transform="rotate(90 146 30)" fill="#00C4F4"/>
                                              </svg>
                                      </div>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      </div>
    </div> -->

  <div class="structure-new" *ngIf="currentPage == 0">

    <div class="struc-card-container-new">
      <div class="struc-card-content-new">
        <div class="card-new" #cardnew>
          <p class="card__date-new">17th October</p>
          <span class="card__title-new">Registration Opens</span>
          <p class="card__subtitle-new">
            Eureka! GCC opens its applications for all entrepreneurs on 10th October. Register by filling your details and logging in to the Eureka! GCC dashboard. Add your co-founders and fill your startup idea details.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">10th December</p>
          <span class="card__title-new">Registration Deadline</span>
          <p class="card__subtitle-new">
            The last date to register for Eureka! GCC
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">17th December</p>
          <span class="card__title-new">Questionnaire Deadline</span>
          <p class="card__subtitle-new">
            Our questionnaire tests the fundamental aspects of your startup idea, including customer segments, target markets, value propositions, and market analysis.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">30th December</p>
          <span class="card__title-new">Semifinalist Declaration</span>
          <p class="card__subtitle-new">
            The top startups from each track are selected for the Semi Final round. This embarks your journey into Eureka! GCC wherein you would be provided with a plethora of opportunities to network, access to mentoring and workshops.          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">31st December - 10th February</p>
          <span class="card__title-new">Workshops and Mentoring</span>
          <p class="card__subtitle-new">
            The selected startups will be given access to exclusive access to dedicated workshops and mentoring orgnanized by the Industry experts and experienced entrepreneurs.        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">15th February</p>
          <span class="card__title-new">Finalist Declaration</span>
          <p class="card__subtitle-new">
            The top Semi-Finalists will be invited for a grand finale
          </div>
          <div class="card-new" #cardnew>
            <p class="card__date-new">10th March</p>
            <span class="card__title-new">Grand Finale</span>
            <p class="card__subtitle-new">
              Hold your nerves to present the final pitch of the competition. It is the grand finale where the top startups from each track of Eureka! GCC compete for the winning prize            </div>
      </div>
    </div>
  </div>
  <!-- <div class="structure-new" *ngIf="currentPage == 1">

    <div class="struc-card-container-new">
      <div class="struc-card-content-new">
        <div class="card-new" #cardnew>
          <p class="card__date-new">5th October - 23rd October</p>
          <span class="card__title-new">1st Round Mentoring</span>
          <p class="card__subtitle-new">
            Get assigned dedicated mentors for exclusive one-on-one sessions.
            Our expert mentors will guide you in developing your business model
            using proven startup methods.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">25th October</p>
          <span class="card__title-new">Preliminary Submission</span>
          <p class="card__subtitle-new">
            This submission will require details about your startup idea with
            insights into your business plan. It will be considered alongside
            the offline pitching evaluation.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">26th - 27th October | 3rd - 4th November</p>
          <span class="card__title-new">Zonals</span>
          <p class="card__subtitle-new">
            Zonals will be held in different zones across the country. You will
            be required to pitch offline in front of the top VCs and investors
            across the country. It will give you an opportunity to network with
            some of the top stakeholders of this ecosystem.
          </p>
        </div>
       
      </div>
    </div>
  </div> -->
  <!-- <div class="structure-new" *ngIf="currentPage == 2">

    <div class="struc-card-container-new">
      <div class="struc-card-content-new">
        <div class="card-new" #cardnew>
          <p class="card__date-new">14th November</p>
          <span class="card__title-new">Semi-Finalist Declaration</span>
          <p class="card__subtitle-new">
            Semi-Finalists are now declared based on the evaluation in the
            zonals. The startups now will receive guidance in building a
            Business Model for their startup.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">14th November - 4th December</p>
          <span class="card__title-new">Customer Validation</span>
          <p class="card__subtitle-new">
            Receive one-on-one mentoring personalised exclusively for
            semi-finalists. Some of the top mentors are exclusively picked to
            provide mentoring to these startups and help them in their
            idea/customer validation process.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">4th December</p>
          <span class="card__title-new">Semi-Finals Submission</span>
          <p class="card__subtitle-new">
            This requires a video pitch submission with emphasis on the Business
            Model Canvas and the Minimum Viable Product (if developed) along
            with report of customer/idea validation of the product
          </p>
        </div>
        
      </div>
    </div>
  </div> -->
  <!-- <div class="structure-new" *ngIf="currentPage == 3">

    <div class="struc-card-container-new">
      <div class="struc-card-content-new">
        <div class="card-new" #cardnew>
          <p class="card__date-new">5th December</p>
          <span class="card__title-new">Finalist Declaration</span>
          <p class="card__subtitle-new">
            Finalists are now declared based on the evaluation in the
            semifinals. The startups now will be invited to IIT Bombay where in
            they will attend Grand Finale of Asia's largest business model
            competition
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">28th December</p>
          <span class="card__title-new">Online Mock Pitching</span>
          <p class="card__subtitle-new">
            Before you present yourself in the grand finale of Eureka!, online
            mock pitching will help you refine your pitches to make your pitch
            more exciting and impactful.
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">E-Summit</p>
          <span class="card__title-new">Grand Finale</span>
          <p class="card__subtitle-new">
            Hold your nerves to present the final pitch of the competition. It
            is the grand finale where the top startups of Eureka! compete for
            the winning prize
          </p>
        </div>
        <div class="card-new" #cardnew>
          <p class="card__date-new">E-Summit</p>
          <span class="card__title-new">Demo Day</span>
          <p class="card__subtitle-new">
            Demo Day sets the stage for startups to pitch their vision to
            investors and industry leaders. Step into the spotlight, engage with
            influential stakeholders, and unleash the power of your startup at
            Demo Day.
          </p>
        </div>
       
      </div>
    </div>
  </div> -->

  <div class="tab-content-wrapper">
    <div id="tab-content-2" class="tab-content">
      <section class="tf-section section-roadmap2 section-bg-1">
        <!-- <div class="tf-heading  mb87 wow fadeInUp">
              <h2 class="heading">ROAD MAP</h2>
          </div> -->

        <!-- <div class="shape1">
              <svg xmlns="http://www.w3.org/2000/svg" width="367" height="383" viewBox="0 0 367 383" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4929)">
                  <path d="M323.437 313.468L237.275 257.43L258.579 357.999L198.674 370.69L177.369 270.12L121.33 356.283L69.9995 322.898L126.038 236.736L25.4685 258.041L12.7778 198.135L113.347 176.83L27.1845 120.792L60.569 69.4609L146.732 125.499L125.427 24.9298L185.332 12.2392L206.637 112.808L262.676 26.6459L314.007 60.0304L257.968 146.193L358.538 124.888L371.228 184.794L270.659 206.099L356.822 262.137L323.437 313.468Z" fill="url(#paint0_linear_2706_4929)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4929" x="0.777344" y="0.238281" width="382.451" height="382.451" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4929"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4929" x1="288.341" y1="43.3381" x2="95.6649" y2="339.591" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div>
          <div class="shape2">
              <svg xmlns="http://www.w3.org/2000/svg" width="321" height="322" viewBox="0 0 321 322" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4928)">
                  <path d="M269.213 262.019L197.968 215.683L215.584 298.84L166.05 309.333L148.434 226.176L102.098 297.421L59.6544 269.817L105.99 198.572L22.8334 216.188L12.3399 166.654L95.4969 149.038L24.2523 102.702L51.8567 60.2583L123.101 106.594L105.485 23.4373L155.019 12.9439L172.635 96.1009L218.971 24.8562L261.415 52.4606L215.079 123.705L298.236 106.089L308.729 155.623L225.572 173.239L296.817 219.575L269.213 262.019Z" fill="url(#paint0_linear_2706_4928)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4928" x="0.339844" y="0.943359" width="320.389" height="320.391" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4928"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4928" x1="240.193" y1="38.6584" x2="80.8762" y2="283.619" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div> -->

        <!-- to fetch timeline from backend - old one -->
        <!-- <div class="container w-100">
              <div class="row">
                  <div class="col-md-12">
                      <div class="tf-roadmap style2" *ngIf="true">
                              <div *ngFor="let idx of zonlist">
                                  <div key={{idx.id}} class="roadmap-box-2 {{idx.classname}}" data-wow-duration="1.5s">
                                      <div class="content">
                                          <h4 class="date">{{idx.dates}}</h4>
                                          <h4 class="title">{{idx.sub_title}}</h4>
                                          <p class="detailing">{{idx.description}}</p>
                                      </div>
                                      <span ></span>
                                      <div class="shape-circle">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="176" height="60" viewBox="0 0 176 60" fill="none">
                                              <path d="M0 30L136 30" stroke="white" stroke-width="2" stroke-dasharray="6 6"/>
                                              <circle cx="146" cy="30" r="30" transform="rotate(90 146 30)" fill="#00C4F4" fill-opacity="0.2"/>
                                              <circle cx="146" cy="30" r="15" transform="rotate(90 146 30)" fill="#00C4F4"/>
                                              </svg>
                                      </div>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div> -->
      </section>
    </div>
  </div>

  <div class="tab-content-wrapper">
    <div id="tab-content-3" class="tab-content">
      <section class="tf-section section-roadmap2 section-bg-1">
        <!-- <div class="tf-heading  mb87 wow fadeInUp">
              <h2 class="heading">ROAD MAP</h2>
          </div> -->

        <!-- <div class="shape1">
              <svg xmlns="http://www.w3.org/2000/svg" width="367" height="383" viewBox="0 0 367 383" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4929)">
                  <path d="M323.437 313.468L237.275 257.43L258.579 357.999L198.674 370.69L177.369 270.12L121.33 356.283L69.9995 322.898L126.038 236.736L25.4685 258.041L12.7778 198.135L113.347 176.83L27.1845 120.792L60.569 69.4609L146.732 125.499L125.427 24.9298L185.332 12.2392L206.637 112.808L262.676 26.6459L314.007 60.0304L257.968 146.193L358.538 124.888L371.228 184.794L270.659 206.099L356.822 262.137L323.437 313.468Z" fill="url(#paint0_linear_2706_4929)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4929" x="0.777344" y="0.238281" width="382.451" height="382.451" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4929"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4929" x1="288.341" y1="43.3381" x2="95.6649" y2="339.591" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div>
          <div class="shape2">
              <svg xmlns="http://www.w3.org/2000/svg" width="321" height="322" viewBox="0 0 321 322" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4928)">
                  <path d="M269.213 262.019L197.968 215.683L215.584 298.84L166.05 309.333L148.434 226.176L102.098 297.421L59.6544 269.817L105.99 198.572L22.8334 216.188L12.3399 166.654L95.4969 149.038L24.2523 102.702L51.8567 60.2583L123.101 106.594L105.485 23.4373L155.019 12.9439L172.635 96.1009L218.971 24.8562L261.415 52.4606L215.079 123.705L298.236 106.089L308.729 155.623L225.572 173.239L296.817 219.575L269.213 262.019Z" fill="url(#paint0_linear_2706_4928)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4928" x="0.339844" y="0.943359" width="320.389" height="320.391" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4928"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4928" x1="240.193" y1="38.6584" x2="80.8762" y2="283.619" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div> -->

        <!-- old one -->
        <!-- <div class="container w-100">
              <div class="row">
                  <div class="col-md-12">
                      <div class="tf-roadmap style2" *ngIf="true">
                              <div *ngFor="let idx of buslist">
                                  <div key={{idx.id}} class="roadmap-box-2 {{idx.classname}}" data-wow-duration="1.5s">
                                      <div class="content">
                                          <h4 class="date">{{idx.dates}}</h4>
                                          <h4 class="title">{{idx.sub_title}}</h4>
                                          <p class="detailing">{{idx.description}}</p>
                                      </div>
                                      <span ></span>
                                      <div class="shape-circle">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="176" height="60" viewBox="0 0 176 60" fill="none">
                                              <path d="M0 30L136 30" stroke="white" stroke-width="2" stroke-dasharray="6 6"/>
                                              <circle cx="146" cy="30" r="30" transform="rotate(90 146 30)" fill="#00C4F4" fill-opacity="0.2"/>
                                              <circle cx="146" cy="30" r="15" transform="rotate(90 146 30)" fill="#00C4F4"/>
                                              </svg>
                                      </div>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div> -->
      </section>
    </div>
  </div>

  <div class="tab-content-wrapper">
    <div id="tab-content-4" class="tab-content">
      <section class="tf-section section-roadmap2 section-bg-1">
        <!-- <div class="tf-heading  mb87 wow fadeInUp">
              <h2 class="heading">ROAD MAP</h2>
          </div> -->

        <!-- <div class="shape1">
              <svg xmlns="http://www.w3.org/2000/svg" width="367" height="383" viewBox="0 0 367 383" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4929)">
                  <path d="M323.437 313.468L237.275 257.43L258.579 357.999L198.674 370.69L177.369 270.12L121.33 356.283L69.9995 322.898L126.038 236.736L25.4685 258.041L12.7778 198.135L113.347 176.83L27.1845 120.792L60.569 69.4609L146.732 125.499L125.427 24.9298L185.332 12.2392L206.637 112.808L262.676 26.6459L314.007 60.0304L257.968 146.193L358.538 124.888L371.228 184.794L270.659 206.099L356.822 262.137L323.437 313.468Z" fill="url(#paint0_linear_2706_4929)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4929" x="0.777344" y="0.238281" width="382.451" height="382.451" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4929"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4929" x1="288.341" y1="43.3381" x2="95.6649" y2="339.591" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div>
          <div class="shape2">
              <svg xmlns="http://www.w3.org/2000/svg" width="321" height="322" viewBox="0 0 321 322" fill="none">
                  <g opacity="0.2" filter="url(#filter0_f_2706_4928)">
                  <path d="M269.213 262.019L197.968 215.683L215.584 298.84L166.05 309.333L148.434 226.176L102.098 297.421L59.6544 269.817L105.99 198.572L22.8334 216.188L12.3399 166.654L95.4969 149.038L24.2523 102.702L51.8567 60.2583L123.101 106.594L105.485 23.4373L155.019 12.9439L172.635 96.1009L218.971 24.8562L261.415 52.4606L215.079 123.705L298.236 106.089L308.729 155.623L225.572 173.239L296.817 219.575L269.213 262.019Z" fill="url(#paint0_linear_2706_4928)"/>
                  </g>
                  <defs>
                  <filter id="filter0_f_2706_4928" x="0.339844" y="0.943359" width="320.389" height="320.391" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2706_4928"/>
                  </filter>
                  <linearGradient id="paint0_linear_2706_4928" x1="240.193" y1="38.6584" x2="80.8762" y2="283.619" gradientUnits="userSpaceOnUse">
                  <stop offset="1"  stopColor="#1D2328"/>
                  <stop offset="1" stopColor="#1D2328" stopOpacity="0"/>
                  </linearGradient>
                  </defs>
                  </svg>
          </div> -->
        <!-- <div class="container w-100">
              <div class="row">
                  <div class="col-md-12">
                      <div class="tf-roadmap style2" *ngIf="true">
                              <div *ngFor="let idx of finlist">
                                  <div key={{idx.id}} class="roadmap-box-2 {{idx.classname}}" data-wow-duration="1.5s">
                                      <div class="content">
                                          <h4 class="date">{{idx.dates}}</h4>
                                          <h4 class="title">{{idx.sub_title}}</h4>
                                          <p class="detailing">{{idx.description}}</p>
                                      </div>
                                      <span ></span>
                                      <div class="shape-circle">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="176" height="60" viewBox="0 0 176 60" fill="none">
                                              <path d="M0 30L136 30" stroke="white" stroke-width="2" stroke-dasharray="6 6"/>
                                              <circle cx="146" cy="30" r="30" transform="rotate(90 146 30)" fill="#00C4F4" fill-opacity="0.2"/>
                                              <circle cx="146" cy="30" r="15" transform="rotate(90 146 30)" fill="#00C4F4"/>
                                              </svg>
                                      </div>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div> -->
      </section>
    </div>
  </div>
</div>
